import { DOMExportOutput } from 'lexical';
import { ReferenceCitationNode, SerializedReferenceCitationNode } from 'modules/Lexical/nodes/ReferenceCitationNode';

export const REFERENCE_CITATION_MARKER = '{r}';

export class ReferenceCitationNodeWithExportDom extends ReferenceCitationNode {
  static getType(): string {
    return super.getType() + '-export';
  }

  static clone(node: ReferenceCitationNodeWithExportDom): ReferenceCitationNodeWithExportDom {
    return new ReferenceCitationNodeWithExportDom(node.__referenceId, node.__text, node.__key);
  }

  static importJSON(
    serializedNode: SerializedReferenceCitationNode,
  ): ReferenceCitationNodeWithExportDom {
    return new ReferenceCitationNodeWithExportDom(serializedNode.referenceId)
      .updateFromJSON(serializedNode);
  }

  exportDOM(): DOMExportOutput {
    const sup = document.createElement('sup');
    sup.setAttribute('data-reference-id', this.getReferenceId());

    const innerSup = document.createElement('sup');
    innerSup.innerText = REFERENCE_CITATION_MARKER;
    sup.appendChild(innerSup);

    return { element: sup };
  }
}
